module.exports = __webpack_public_path__ + "img/peixun.92f7706b.png";